import { render } from "./Produkte_info.vue?vue&type=template&id=1c0aa867"
import script from "./Produkte_info.vue?vue&type=script&lang=js"
export * from "./Produkte_info.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\stfg.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__